import RcsLink from './RcsLink';

export default RcsLink;
